import React from 'react'
import { useWatch } from 'react-hook-form'
import { ReactSortable } from 'react-sortablejs'
import { Form } from 'semantic-ui-react'
import styled from 'styled-components'

interface SortingProps {
  activeIndex: number
  question: any
  control: any
  setValue: (name: string, data: any) => void
}

const StyledAnswer = styled.div`
  font-size: 15px !important;
  margin-bottom: 5px;
  border: 1px solid #e5e7eb;
  padding: 7px;
  border-radius: 5px;    
  color: #4183c4;
  cursor: grab !important;
  margin-left: 10px;
`

const Sorting: React.FC<SortingProps> = (props) => {
  const { activeIndex, question, control, setValue } = props
  const watchAnswers = useWatch({ control, name: `questions[${activeIndex}].answers` })

  function renderSortItems() {
    return watchAnswers?.map((answer, index) => {
      return <StyledAnswer key={answer.id}>
        {`${index + 1}. ${answer.text}`}
      </StyledAnswer>
    })
  }

  return <>
    <Form.Field label={question?.question} required={Boolean(question?.required)} />
    <ReactSortable
      list={watchAnswers || []}
      animation={150}
      delayOnTouchOnly={true}
      delay={2}
      setList={(newState) => setValue(`questions[${activeIndex}].answers`, newState)}
    >
      {renderSortItems()}
    </ReactSortable>
  </>
}
export default Sorting